export default __webpack_public_path__ + "static/media/img_01.296c7b20.jpg";